__turbopack_context__.v({
  "dot": "MobileTxRow-module-scss-module__5FNnPq__dot",
  "errorTx": "MobileTxRow-module-scss-module__5FNnPq__errorTx" + " " + "MobileTxRow-module-scss-module__5FNnPq__txUsdAmount",
  "errorTxGrey": "MobileTxRow-module-scss-module__5FNnPq__errorTxGrey",
  "time": "MobileTxRow-module-scss-module__5FNnPq__time",
  "txAmount": "MobileTxRow-module-scss-module__5FNnPq__txAmount",
  "txDetails": "MobileTxRow-module-scss-module__5FNnPq__txDetails",
  "txGreen": "MobileTxRow-module-scss-module__5FNnPq__txGreen",
  "txIcon": "MobileTxRow-module-scss-module__5FNnPq__txIcon",
  "txIconError": "MobileTxRow-module-scss-module__5FNnPq__txIconError" + " " + "MobileTxRow-module-scss-module__5FNnPq__txIcon",
  "txIconGradient": "MobileTxRow-module-scss-module__5FNnPq__txIconGradient" + " " + "MobileTxRow-module-scss-module__5FNnPq__txIcon",
  "txIconLoading": "MobileTxRow-module-scss-module__5FNnPq__txIconLoading" + " " + "MobileTxRow-module-scss-module__5FNnPq__txIcon",
  "txRed": "MobileTxRow-module-scss-module__5FNnPq__txRed",
  "txRow": "MobileTxRow-module-scss-module__5FNnPq__txRow",
  "txTokenAmount": "MobileTxRow-module-scss-module__5FNnPq__txTokenAmount",
  "txType": "MobileTxRow-module-scss-module__5FNnPq__txType",
  "txUsdAmount": "MobileTxRow-module-scss-module__5FNnPq__txUsdAmount",
});
